export const SKILLS_LIST = [
	'Small and large business experience',
	'React JS and Redux',
	'TypeScript for type-safe, maintainable code',
	'Preprocessed CSS (Less and SCSS)',
	'Responsive CSS with Media Queries',
	'Node.js Server-side rendering for SEO and optimization',
	'JavaScript unit testing',
	'SQL and RESTful API integration',
	'Internationalization (i18n) for global accessibility',
	'Legacy framework migration (AngularJS to React)',
	'Mentoring and pair-programming',
	'AI-assisted development with Claude Code',
];
